import { render, staticRenderFns } from "./LanguageSelectbox.vue?vue&type=template&id=09ceee4f"
import script from "./LanguageSelectbox.vue?vue&type=script&lang=js"
export * from "./LanguageSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports